<template>
  <section
    class="lp-features"
    :style="{
      backgroundColor: section.styles.backgroundColor || '#f7faf8',
      padding: section.styles.padding || '5rem 1.25rem',
      textAlign: section.styles.textAlign || 'center',
    }"
  >
    <div class="max-w-5xl mx-auto">
      <h2 v-if="section.content.title" class="lp-features__title">{{ section.content.title }}</h2>
      <p v-if="section.content.subtitle" class="lp-features__subtitle">{{ section.content.subtitle }}</p>
      <div class="lp-features__grid">
        <div
          v-for="(item, index) in section.content.items || []"
          :key="index"
          class="lp-feature"
        >
          <div class="lp-feature__icon">
            <icon :name="item.icon || 'tick'" class="h-5 w-5" />
          </div>
          <h3 class="lp-feature__name">{{ item.title }}</h3>
          <p class="lp-feature__desc">{{ item.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Icon from '@/Shared/Icon.vue'

export default {
  components: { Icon },
  props: {
    section: { type: Object, required: true },
    preview: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.lp-features__title {
  font-family: var(--ps-font-display);
  font-size: clamp(1.75rem, 3vw, 2.35rem);
  font-weight: 700;
  letter-spacing: -0.03em;
  color: #0f172a;
  margin-bottom: 0.65rem;
}

.lp-features__subtitle {
  font-size: 1.05rem;
  color: #64748b;
  max-width: 34rem;
  margin: 0 auto 2.75rem;
  line-height: 1.55;
}

.lp-features__grid {
  display: grid;
  gap: 1.75rem 1.5rem;
}

@media (min-width: 768px) {
  .lp-features__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 2rem 2.25rem;
  }
}

.lp-feature {
  text-align: inherit;
  padding: 0.25rem 0.15rem;
}

.lp-feature__icon {
  display: inline-flex;
  height: 2.6rem;
  width: 2.6rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.85rem;
  margin-bottom: 1rem;
  background: color-mix(in srgb, var(--lp-primary-color, #0f766e) 14%, white);
  color: var(--lp-primary-color, #0f766e);
}

.lp-feature__name {
  font-size: 1.1rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.015em;
  margin-bottom: 0.45rem;
}

.lp-feature__desc {
  font-size: 0.95rem;
  color: #64748b;
  line-height: 1.6;
}
</style>
